import { useIntl } from 'react-intl';

import { Dropdown } from 'components/Forms';

interface ISubgroupsProps {
  handleChange: any;
  options: ISelectOption[];
  value: ISelectOption[];
  disabled?: boolean;
}

const Subgroups = ({ handleChange, options, value, disabled }: ISubgroupsProps) => {
  const intl = useIntl();

  return (
    <Dropdown
      variant="form"
      dataTestId="filter-subgroups"
      options={options}
      placeholder={intl.formatMessage({ id: 'selectGroup' })}
      onChange={handleChange}
      isMulti
      value={value}
      isDisabled={disabled}
      isClearable={false}
      minWidth={200}
      label={intl.formatMessage({ id: 'groupsKey' })}
    />
  );
};

export default Subgroups;
